export const text = {
  family: {
    primary: 'system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji"',
    handwriting: "'Gloria Hallelujah', cursive",
    reading: "'Baskervville', serif",
    spartan: "'League Spartan', sans-serif",
  },

  size: {
    primary: '14px', // aka 1.75rem
    small: '12px', // aka 1.5rem
    handwriting: '80%',
    reading: '16px', // aka 2rem
    sourceTitle: '24px', // aka 3rem
    sourceTitleSticky: '22px', // aka 2.75rem
  },

  height: {
    tight: '1.2em',
    primary: '1.5em',
    highlight: '1.4em',
    header: '1.2em',
  },

  weight: {
    bold: '600',
    medium: '500',
    regular: '400',
    thin: '300',
  },
};
